import Affix from './affix';
export default Affix;

